var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressBar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 4,
    viewBox: "0 0 343 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 4,
    rx: 2,
    fill: "#D4D7DE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 108.316,
    height: 4,
    rx: 2,
    fill: "#FF6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBar2);
export default __webpack_public_path__ + "static/media/progress-bar2.e8833b557d614482e97bd4c331fac706.svg";
export { ForwardRef as ReactComponent };